import React from 'react';
import { Card, CardContent } from './ui/card';
import { Plane, Hotel, Users } from 'lucide-react';
import { Price } from '../context/CurrencyContext';
import { PayButton, VoucherButton } from './PaymentButtons';

const STATUS = {
  reserved: 'bg-blue-100 text-blue-700',
  confirmed: 'bg-green-100 text-green-700',
  cancelled: 'bg-red-100 text-red-700',
};

export const TravelBookingCard = ({ b, action }) => {
  const Icon = b.booking_type === 'flight' ? Plane : Hotel;
  const o = b.offer;
  return (
    <Card className="border-0 shadow-md" data-testid={`travel-booking-${b.booking_id}`}>
      <CardContent className="p-5 flex flex-col md:flex-row md:items-center gap-4">
        <div className="w-12 h-12 rounded-lg bg-gradient-to-br from-teal-500 to-cyan-600 flex items-center justify-center text-white flex-shrink-0"><Icon className="w-6 h-6" /></div>
        <div className="flex-1 min-w-0">
          <div className="flex flex-wrap items-center gap-2">
            <p className="font-bold text-gray-900">{b.summary}</p>
            <span className={`text-xs font-semibold px-2 py-0.5 rounded-full capitalize ${STATUS[b.status] || 'bg-gray-100 text-gray-700'}`} data-testid={`travel-status-${b.booking_id}`}>{b.status}</span>
          </div>
          <p className="text-sm text-gray-500 mt-1">
            Ref <span className="font-mono font-semibold text-gray-700">{b.reference}</span>
            {b.booking_type === 'flight' ? ` · ${o.cabin} · ${o.stops ? `1 stop via ${o.via}` : 'Non-stop'} · ${o.baggage}` : ` · ${o.room_type} · ${o.rooms} room(s)`}
          </p>
          <p className="text-xs text-gray-500 mt-1 flex items-center"><Users className="w-3 h-3 mr-1" />{b.travelers.map((t) => t.name).join(', ')}</p>
        </div>
        <div className="text-right">
          <Price inr={b.total_price} className="block text-xl font-bold text-teal-700" />
          <p className="text-xs text-gray-500" data-testid={`travel-payment-${b.booking_id}`}>{b.payment_status === 'paid' ? 'Paid ✓' : 'Payment pending'}</p>
          {action || (
            <div className="flex gap-2 justify-end mt-2">
              <VoucherButton kind="travel" bookingId={b.booking_id} />
              {b.payment_status !== 'paid' && b.status !== 'cancelled' && <PayButton kind="travel" bookingId={b.booking_id} amountInr={b.total_price} />}
            </div>
          )}
        </div>
      </CardContent>
    </Card>
  );
};
